import React from "react";
import { useTranslation } from "react-i18next";
import "./Cards.css";
import CardItem from "../CardItem/CardItem";

function Cards() {
  const { t } = useTranslation();

  return (
    <div className="cards">
      <h1>Check out the core features of Onenizer</h1>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="/images/note.png"
              text={t("tasksNotes.description")}
              label={t("tasksNotes.title")}
              path="/app"
            />
            <CardItem
              src="/images/shopping.png"
              text={t("shoppingList.description")}
              label={t("shoppingList.title")}
              path="/app"
            />
          </ul>

          <ul className="cards__items">
            <CardItem
              src="/images/timetable.png"
              text={t("schedule.description")}
              label={t("schedule.title")}
              path="/app"
            />
            <CardItem
              src="/images/finance.png"
              text={t("finance.description")}
              label={t("finance.title")}
              path="/app"
            />
            <CardItem
              src="/images/vote.png"
              text={t("voting.description")}
              label={t("voting.title")}
              path="/app"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
